import React from "react";
import { hypertensionIntro } from "../../Util/writing";
import { getNarrowTextDivStyle } from "../../Util/util";

const HypertensionIntro = (props) => {
  return <div style={getNarrowTextDivStyle(props.width)}>{hypertensionIntro}</div>;
};
export default HypertensionIntro;
